import { MonitorsTable } from './MonitorsTable';
import { MonitorUpsellCard } from './MonitorUpsellCard';
import React from 'react';
import { Space } from 'antd';
import { ViewArea } from '@ui/general';

export const MonitorsView : React.FC = () =>
	<ViewArea
		collapseSidebar
		direction='vertical'
		fullWidth
		id='data-security-monitors-view'>
		<Space direction='vertical'>
			<MonitorUpsellCard />
			<MonitorsTable />
		</Space>
	</ViewArea>;
